export default {
  incidents: [],
  incident: undefined,
  incidentsInMyArea: undefined,
};
